(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-singles/assets/javascripts/coupon-choice/single-coupon-xpert.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-singles/assets/javascripts/coupon-choice/single-coupon-xpert.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useState,
  useContext,
  useEffect
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  XPERT_WAGER_SROW
} = svs.components.tipsen.engine.constants.xpertWagerSystemTypes;
const {
  DrawContext
} = svs.components.tipsen.drawProvider;
const {
  selectHasBoardUserSigns,
  selectXpertAnalysisAuthorId,
  selectNumberOfBoards,
  selectBoardUserSigns,
  selectPixSizeSingleRow
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  reactForm,
  ReactButton
} = svs.ui;
const {
  Fieldset,
  RadioButton,
  RadioGroup
} = reactForm;
const {
  useAnalyses
} = svs.components.sportinfo.gameAnalysesRedux.hooks;
const {
  useIsCurrentDrawPlayable
} = svs.components.tipsen.hooks;
const {
  useGenerateSportPixCouponAction
} = svs.components.tipsen.engine.utils.helpers;
const BASEROW_EMPTY = 'BASEROW_EMPTY';
const BASEROW_USER_SIGNS = 'BASEROW_USER_SIGNS';
const SingleCouponXpertButton = _ref => {
  let {
    selectedBoardIndex,
    onClick,
    boardIndex,
    disabled
  } = _ref;
  const numRows = boardIndex + 1;
  const buttonTitle = numRows === 1 ? '1 Rad' : "".concat(numRows, " Rader");
  const isSelected = selectedBoardIndex === boardIndex;
  return React.createElement(ReactButton, {
    "aria-checked": isSelected,
    checked: isSelected,
    className: "tipsen-pix-system-selector-button f-bold",
    disabled: disabled,
    inverted: isSelected,
    onClick: onClick,
    role: "radio",
    thin: true,
    transparent: !isSelected
  }, React.createElement("span", {
    className: "f-200"
  }, buttonTitle));
};
const SingleCouponXpert = _ref2 => {
  let {
    couponId
  } = _ref2;
  const generateSportPixCoupon = useGenerateSportPixCouponAction();
  const isDrawPlayable = useIsCurrentDrawPlayable();
  const nrOfPixBoards = useSelector(state => selectPixSizeSingleRow(state, couponId));
  const [selectedPixSystem, setSelectedPixSystem] = useState(nrOfPixBoards > 0 ? nrOfPixBoards - 1 : 0);
  const {
    productId,
    drawNumber
  } = useContext(DrawContext);
  const boardSize = useSelector(state => selectNumberOfBoards(state, couponId));
  const dispatch = useDispatch();
  const hasUserSigns = useSelector(state => selectHasBoardUserSigns(state, couponId, 0));
  const userSigns = useSelector(state => selectBoardUserSigns(state, couponId, 0));
  const xpertAnalysisAuthorId = useSelector(state => selectXpertAnalysisAuthorId(state, couponId));
  const [baseRow, setBaseRow] = useState(() => {
    if (hasUserSigns) {
      return BASEROW_USER_SIGNS;
    } else if (xpertAnalysisAuthorId) {
      return xpertAnalysisAuthorId;
    }
    return BASEROW_EMPTY;
  });
  const {
    baseRows
  } = useAnalyses(productId, drawNumber);
  useEffect(() => {
    if (!hasUserSigns && baseRow === BASEROW_USER_SIGNS) {
      setBaseRow(BASEROW_EMPTY);
    }
  }, [hasUserSigns, setBaseRow, baseRow]);
  const onGeneratePixRows = (boardIndex, _baseRow) => {
    const numRows = boardIndex + 1;
    const dispatchAction = () => {
      let options = {
        productId,
        system: 1,
        numRows,
        drawNumber,
        couponId,
        baseRow: [],
        type: XPERT_WAGER_SROW,
        keepUserSigns: false
      };
      if (_baseRow === BASEROW_USER_SIGNS) {
        options = _objectSpread(_objectSpread({}, options), {}, {
          baseRow: userSigns,
          keepUserSigns: true
        });
      } else if (_baseRow !== BASEROW_EMPTY) {
        options = _objectSpread(_objectSpread({}, options), {}, {
          baseRow: baseRows[_baseRow],
          xpertAnalysisAuthorId: baseRow
        });
      }
      dispatch(generateSportPixCoupon({
        data: options
      }));
    };
    if (hasUserSigns && baseRow !== BASEROW_USER_SIGNS) {
      svs.components.dialog.api.add(new svs.components.dialog.Confirm({
        actions: [{
          title: 'Avbryt'
        }, {
          callback() {
            svs.components.dialog.api.close();
            dispatchAction();
          },
          title: 'Fortsätt'
        }],
        message: [{
          text: 'Vill du fortsätta ändå?',
          type: svs.components.dialog.message.TEXT
        }],
        branding: svs.components.dialog.branding.SPORT,
        icon: 'dustbin',
        title: 'Dina tecken kommer att rensas'
      }));
    } else {
      dispatchAction();
    }
  };
  const pixButtons = [];
  for (let boardIndex = 0; boardIndex < boardSize; boardIndex++) {
    pixButtons.push( React.createElement(SingleCouponXpertButton, {
      boardIndex: boardIndex,
      disabled: !isDrawPlayable,
      key: boardIndex,
      onClick: () => {
        setSelectedPixSystem(boardIndex);
        onGeneratePixRows(boardIndex, baseRow);
      },
      selectedBoardIndex: selectedPixSystem
    }));
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "f-550 tipsen-pix-selector-header-txt"
  }, "Utg\xE5 ifr\xE5n"), React.createElement(Fieldset, {
    className: "xpert-choices",
    legend: "V\xE4lj tecken att utg\xE5 ifr\xE5n",
    srOnly: true
  }, React.createElement(RadioGroup, {
    className: "two-col",
    size: "200",
    thin: true
  }, React.createElement(RadioButton, {
    checked: baseRow === BASEROW_EMPTY,
    inline: true,
    name: "xpert-choice",
    onChange: event => {
      setBaseRow(event);
    },
    value: BASEROW_EMPTY
  }, "Grunden"), React.createElement(RadioButton, {
    checked: baseRow === BASEROW_USER_SIGNS,
    disabled: !hasUserSigns,
    inline: true,
    name: "xpert-choice",
    onChange: event => {
      setBaseRow(event);
    },
    value: BASEROW_USER_SIGNS
  }, "Egna val"))), React.createElement("div", {
    className: "tipsen-pix-selector-grid-singel-row"
  }, pixButtons));
};
setGlobal('svs.components.tipsen.routePlaySingles.SingleCouponXpert', SingleCouponXpert);

 })(window);